import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import loadableWithRetry from '../common/loadableWithRetry';

const FilterPage = loadableWithRetry(() => import('./FilterResults.js'));
const FilterPageBeta = loadableWithRetry(() =>
  import('./FilterResultsBeta.js')
);
const SmartFilterPage = loadableWithRetry(() =>
  import('./SmartFilterResults.js')
);

const FilterResults = (props) => {
  const [shouldRender, setShouldRender] = useState(false);
  const containerRef = useRef(null);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setShouldRender(true);
          hasFetched.current = true;
          observerInstance.disconnect();
        }
      },
      {
        root: null,
        rootMargin: '200px',
        threshold: 0,
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  if (!shouldRender) {
    return <div ref={containerRef} style={{ minHeight: '400px' }} />;
  }

  return (
    <Router>
      <Route
        path="/"
        render={(routeProps) => <FilterPage {...props} {...routeProps} />}
      />
    </Router>
  );
};

export const FilterResultsBeta = (props) => {
  return (
    <Router>
      <Route
        path="/"
        render={(routeProps) => <FilterPageBeta {...props} {...routeProps} />}
      />
    </Router>
  );
};

export const SmartFilterResults = (props) => {
  return (
    <Router>
      <Route
        path="/"
        render={(routeProps) => <SmartFilterPage {...props} {...routeProps} />}
      />
    </Router>
  );
};

export default FilterResults;
